import {EventInitState, SeedEvent} from '@/store/event/event.types';
import {EventMutations} from '@/store/event/event.mutations';
import {EventAction} from '@/store/event/event.actions';

const namespaced = true;

export const eventInitState: EventInitState = {
  eventList: [{}] as SeedEvent[],
  eventMember: [{}] as SeedEvent[],
  eventMemberMain: [{}] as SeedEvent[],
  eventTime: [{}] as SeedEvent[],
  eventTotal: 0
};

export const eventState = {
  namespaced,
  state: eventInitState,
  actions: EventAction,
  mutations: EventMutations,
  // getters
};
